import { useMemo } from 'react';

// models
import { CreateFilterAttributeModel } from '../../models/contact_attributes.model';
import { FormulaDetailModel } from '../../models/formula.model';

// hooks
import useAudienceMainQuery from './usAudienceMainQuery';
import useAudienceQuery from './useAudienceQuery';

export default function useReachableUsers(formula: FormulaDetailModel) {
    const { data: selectedAudience, isLoading: audienceLoading } =
        useAudienceQuery(formula?.audiences?.[0]?.audience_id);

    const query = useMemo<CreateFilterAttributeModel[]>(() => {
        if (selectedAudience) {
            const result: CreateFilterAttributeModel[] = [];
            selectedAudience?.filters.forEach((item) =>
                result.push({
                    attribute: {
                        value: item.attribute.id,
                        label: item.attribute.attribute_name,
                    },
                    operator: {
                        value: item.operator.id,
                        label: item.operator.display_name,
                    },
                    value: item.value,
                }),
            );
            return result;
        }
        return [];
    }, [selectedAudience]);

    const { data, isLoading: audienceMetricLoading } = useAudienceMainQuery(
        query,
        false,
        true,
    );

    return { data, isLoading: audienceMetricLoading || audienceLoading };
}
